import { render, staticRenderFns } from "./CancelEntrustedHousing.vue?vue&type=template&id=1349f8ac&scoped=true"
import script from "./CancelEntrustedHousing.vue?vue&type=script&lang=js"
export * from "./CancelEntrustedHousing.vue?vue&type=script&lang=js"
import style0 from "./CancelEntrustedHousing.vue?vue&type=style&index=0&id=1349f8ac&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1349f8ac",
  null
  
)

export default component.exports